import { render } from "./ScheduleGrid.vue?vue&type=template&id=2b1941a4&ts=true"
import script from "./ScheduleGrid.vue?vue&type=script&lang=ts"
export * from "./ScheduleGrid.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__